var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirplane = function SvgAirplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.623 36.377H6.65a4.971 4.971 0 0 1 0-9.908h7.886l5.074-5.075-13.92-8.571a4.97 4.97 0 0 1-1.78-6.549 5.04 5.04 0 0 1 6.857-2.64l18.171 8.4 8.777-8.88a5.043 5.043 0 0 1 7.132 7.132l-8.88 8.777 8.4 18.343a5.006 5.006 0 0 1-2.64 6.685 4.97 4.97 0 0 1-6.549-1.782l-8.571-13.92-5.075 5.074v7.886a4.971 4.971 0 0 1-9.908 0z"
  })));
};
export default SvgAirplane;